module.exports = __webpack_public_path__ + "static/media/circuit2.bfb7870a.png";